import { Badge, Card, Heading, HStack, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { CardInfoViewProps } from "@repo/core/screens/Proposals/screens/ProposalsViewInfo/components/CardInfoView/types";

export const CardInfoView = ({
  children,
  title,
  subTitle,
  borderRadius = "$lg",
  borderColor = "$backgroundLight200",
  borderWidth = 1,
  p = "$0",
  ...props
}: CardInfoViewProps) => {
  const { isMobile } = useDimensions();

  return (
    <Card
      w="$full"
      alignSelf="stretch"
      minWidth={0}
      {...props}
      overflow="hidden"
      borderRadius={borderRadius}
      borderWidth={!isMobile ? borderWidth : 0}
      p={p}
      borderColor={borderColor}
    >
      {!isMobile && title ? (
        <HStack
          borderBottomWidth="$2"
          alignItems="center"
          p="$2"
          pl="$4"
          minWidth={0}
          borderBottomColor="$backgroundLight200"
        >
          <Heading
            fontWeight={700}
            flex={1}
            color="$textLight800"
            fontSize="$lg"
          >
            {title}
          </Heading>
          {subTitle ? (
            <Badge
              action="muted"
              borderRadius="$sm"
              size="md"
              bgColor="$backgroundLight100"
              py="$1"
              px="$2"
            >
              <Text
                h={22}
                fontWeight={500}
                fontSize="$md"
                alignItems="center"
                display="flex"
                justifyContent="center"
                color="$backgroundLight950"
              >
                {subTitle}
              </Text>
            </Badge>
          ) : null}
        </HStack>
      ) : null}
      <VStack p="$4" w="$full">
        {children}
      </VStack>
    </Card>
  );
};
